import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminBuilding_groups = z.any()
export type TagsGetAdminBuilding_groups = z.infer<typeof tagsGetAdminBuilding_groups>

export const querystringGetAdminBuilding_groups = z.object({ "municipalityId": z.string().uuid() })
export type QuerystringGetAdminBuilding_groups = z.infer<typeof querystringGetAdminBuilding_groups>

export const responseGetAdminBuilding_groups = z.object({ "payload": z.array(z.object({ "id": z.string().uuid(), "municipalityId": z.string().uuid(), "name": z.string(), "address": z.string().optional(), "image": z.string().optional(), "createdAt": z.string(), "updatedAt": z.string(), "buildingCount": z.number(), "buildings": z.array(z.object({ "id": z.string().uuid(), "name": z.string(), "municipalityId": z.string().uuid(), "address": z.string().optional(), "image": z.string().optional() })) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminBuilding_groups = z.infer<typeof responseGetAdminBuilding_groups>

interface IGetAdminBuilding_groups extends BaseMethodType {
  tags: TagsGetAdminBuilding_groups,
  querystring: QuerystringGetAdminBuilding_groups,
  response: ResponseGetAdminBuilding_groups
}
export const URL = '/admin/building-groups'
export const validation = {
  get: {
    tags: tagsGetAdminBuilding_groups,
    querystring: querystringGetAdminBuilding_groups,
    response: responseGetAdminBuilding_groups
  }
}
export interface AdminBuilding_groups extends BaseRouteType {
  get: IGetAdminBuilding_groups
}